import React from 'react';
export default () => <div>Checkout</div>;
